





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";

@Component
export default class ReturnReasonDialog extends Vue {
  @Prop({ default: "OK" }) buttonOK!: string;
  @Prop({ default: "" }) returnReason!: string;

  //開いているかどうか
  private isActive = false;

  //開く
  public open() {
    this.isActive = true;
  }

  @Emit()
  private download() {
    return;
  }
  @Emit()
  private reload() {
    return;
  }

  //OK
  private ok() {
    this.isActive = false;
    this.reload();
  }
}
